module.exports = __webpack_public_path__ + "static/img/uncatering_logo.5abce1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uncatering_logo.png
// module id = RJPX
// module chunks = 0 2 20